import {
   Card,
   CardProps,
   CardContent,
   CardHeader,
   Icon,
   CardActions,
   CardRight,
} from '~/ui-components';
import { Assessment } from '../Stage';
import { IconButton } from '@chakra-ui/react';
import { useLocalization } from '~/framework';
import { useStageEditor } from '../StageEditor';
import { SignoffTeamSelector } from './SignoffTeamSelector';
import { faTrashCan } from '@fortawesome/pro-regular-svg-icons';

type EditSignoffCardProps = CardProps & {
   assessment: Assessment;
};

export function EditSignoffCard({ assessment, ...props }: EditSignoffCardProps) {
   const { _js } = useLocalization();

   const stageEditor = useStageEditor();

   return (
      <Card sizing="md" aria-label={_js('Sign-Off Card')} {...props}>
         <CardContent>
            <CardHeader>{_js('Stage Sign-Off')}</CardHeader>
         </CardContent>
         <CardRight>
            <CardActions>
               <SignoffTeamSelector
                  teamid={assessment.teamid_signer}
                  onSelect={(teamid: number, name: string, avatarUrl?: string) => {
                     stageEditor.updateAssessment(assessment, {
                        ...assessment,
                        teamid_signer: teamid,
                        signoffTeam: {
                           teamid: teamid,
                           name: name,
                           image: avatarUrl ?? '',
                        },
                     });
                  }}
               />
               {/* We're hiding this, until skills is utilized more broadly,
                     and the logic around how skill ratings are influenced by stage
                     assessments has been discussed futher.
                  <SkillRatingDropdown
                     value={assessment.skills_points_possible}
                     onChange={value =>
                        stageEditor.updateAssessment(assessment, {
                           ...assessment,
                           skills_points_possible: value / 4,
                        })
                     }
                  />
               */}
               <IconButton
                  aria-label={_js('Remove Assessment')}
                  icon={<Icon type={faTrashCan} />}
                  onClick={() => stageEditor.removeAssessment(assessment)}
                  _hover={{ backgroundColor: 'red.300' }}
               />
            </CardActions>
         </CardRight>
      </Card>
   );
}
